import { Component, OnInit } from "@angular/core";
import { ChildEntityDisplayComponent } from "@app/view/shared/child-entity-display/child-entity-display.component";
import { PropertyTooltipDirective } from "./property-tooltip.directive";

@Component({
  selector: "app-resource-rule-render",
  templateUrl: "./resource-rule-render.component.html",
  styleUrls: ["./resource-rule-render.component.css"],
  imports: [PropertyTooltipDirective]
})
export class ResourceRuleRenderComponent
  extends ChildEntityDisplayComponent
  implements OnInit
{
  ngOnInit() {
    this._resource?.getRelation(this._relation).subscribe((value) => {
      console.log("Resource Rule value: ", value);
      this.displayValue = value[this._displayField];
    });
  }
}
